import type { ComponentProps } from "react";
import "./ExtractCallout.css"

export type ExtractCalloutProps = ComponentProps<"div"> & {
	title: string;
	icon?: string;
	variant?:
		| "default"
		| "custom-primary"
		| "success"
		| "custom-warning"
		| "custom-gray"
		| "success"
		| "warning"
		| "danger";
};

export function ExtractCallout({
	title,
	children,
	icon,
	variant = "default",
}: ExtractCalloutProps) {
	return (
		<div
			className={[
				`callout-${variant}`,
				"callout display-flex gap-10 rounded-none",
			].join(" ")}
		>
			{icon && (
				<span
					className={[
						icon,
						`text-color-${variant}`,
						"rioglyph rioglyph-align-bottom",
						"text-size-20",
					].join(" ")}
				/>
			)}
			<div>
				<div
					className={`text-color-${variant} text-medium text-size-20 line-height-125rel margin-bottom-10`}
				>
					{title}
				</div>
				<p>{children}</p>
			</div>
		</div>
	);
}
